import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../../app/app.service';
import { AddSlideComponent } from '../add-slide/add-slide.component';
import { AddTrainingCategoryComponent } from '../add-training-category/add-training-category.component';
import { TrainingCategoriesVM, TrainingCatgoriesAndSections, TrainingCatVM, TrainingInfo, TrainingSlidesVM, TrainingSubSectionsVM, TrainingVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-setup-training',
  templateUrl: './setup-training.component.html',
  styleUrls: ['./setup-training.component.scss']
})
export class SetupTrainingComponent implements OnInit {
  TrainingCategories: TrainingCatVM[];
  TrainingId: number = 0;
  TrainingInfo: TrainingInfo;
  SubTrainings: TrainingSubSectionsVM[];
  Slides: TrainingSlidesVM[];

  SlideInfo: TrainingSlidesVM;
  constructor(private _dialog: MatDialog,
    private _appService: AppService, private _trainingService: TrainingService,) { }

  ngOnInit() {
    //console.log("loadddd____111")
    this._appService.setPageTitle('Setup Training');
    this.LoadTrainingCatList();
  }

  LoadTrainingCatList() {
    this._trainingService.GetTrainingTypes().subscribe(res => {
     // console.log('result_types', res)
      this.TrainingCategories = res;

    })
  }

  LoadTrainingDetails() {
    this._trainingService.GetSelectedTrainingInfo(this.TrainingId).subscribe(res => {
      //console.log("result_tarining sections", res)
      this.TrainingInfo = res;
      this.SubTrainings = this.TrainingInfo.SubTrainings;
      this.Slides = this.TrainingInfo.Slides;
    })
  }

  TrainingSelect() {
    if (this.TrainingId > 0) {
      this.LoadTrainingDetails();
    }
  }

  OpenAddSubTraining() {
    const addCategoeynDialog = this._dialog.open(AddTrainingCategoryComponent, {
      data: {
        isTrainingSection: true,
        parentCatId: this.TrainingId,
      }
    });
    addCategoeynDialog.afterClosed().subscribe(details => {
      if (details == true) {
        this.LoadTrainingDetails();
      }
    });
  }
  OpenEditSubTraining(SubtraingId: number, isParent: boolean, Name: string) {
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {

      data: {
        sectionId: SubtraingId,
        isSection: false,
        isCategoeryEdit: false,
        isTrainingEdit: false,
        isSubTrainingEdit: true,

        Name: Name,
        isUpdateCat: 0,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details == true) {
        this.LoadTrainingDetails();
      }
    });
  }

  OpenAddSlide(TrainingId: number, SectionId: boolean) {
    const addSectionDialog = this._dialog.open(AddSlideComponent, {

      data: {
        TrainingId: TrainingId,
        SectionId: SectionId,
        isAddSlide: true,

      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details == true) {
        this.LoadTrainingDetails();
      }
    });
  }


  OpenEditSlide(SlideId: number) {

    this._trainingService.GetSelectedSlideInfo(SlideId).subscribe(res => {
      
      this.SlideInfo = res;
      if (this.SlideInfo != null) {
        const addSectionDialog = this._dialog.open(AddSlideComponent, {

          data: {
            isEditSlide: true,
            SlideInfo: this.SlideInfo,
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
          if (details == true) {
            this.LoadTrainingDetails();
          }
        });
      }
    });

  }

  toggleSlideActive(slideId:number, Active:boolean){
    this._trainingService.TogglelTrainingSlide(slideId,Active).subscribe(res=>{
      this.LoadTrainingDetails();
    })
  }

  

  OrderUP_Slide(order:number, sectionId:number){
    this._trainingService.OrderUp_Slide(order,sectionId).subscribe(res=>{
      this.LoadTrainingDetails();
    })
  }
  OrderDown_Slide(order:number, sectionId:number){
    this._trainingService.OrderDown_Slide(order,sectionId).subscribe(res=>{
      this.LoadTrainingDetails();
    })
  }


  
}
